/**
 * Communications flow library — types + helpers (Greg's flow-naming work).
 *
 * #635 seed-guard (2026-07-08 merge): the example-flow seed rows were removed —
 * the array below is EMPTY in app source. Example flows are the mock layer's
 * to serve via listBuilderFlows (REQ-002 resolved).
 */
import type { FBFlow } from "../builder/fb-model";
import { t as i18nT } from "../../lib/i18n";

export interface SeedFlow extends FBFlow {
  id: string;
  name: string;
  eventKind: string;
  desc: string;
}

// #635: baked flow library removed — served via listBuilderFlows /
// @v0y4ge/api-mocks (REQ-002).

/* Per-kind pill colors (2026-08-12, operator): each event type gets its OWN
 * color — the old 3-tone grouping made Queue/Public share green and
 * Invitation/Appointment share purple. Hues follow the All-features launcher's
 * section palette (events pink, queues gold, appointments teal) so category
 * color means the same thing everywhere. `tone` stays for back-compat with
 * consumers that don't read bg/fg. */
export const FLOW_KIND_PILL: Record<string, { label: string; labelKey: string; tone: "primary" | "success" | "warn"; bg: string; fg: string }> = {
  invite: { labelKey: "messaging.flowsSeed.invitationEvent", get label() { return i18nT("messaging.flowsSeed.invitationEvent"); }, tone: "primary", bg: "#EFE9FD", fg: "#5B2EC9" },
  public: { labelKey: "messaging.flowsSeed.publicEvent", get label() { return i18nT("messaging.flowsSeed.publicEvent"); }, tone: "success", bg: "#FBE7EE", fg: "#B01547" },
  private: { labelKey: "messaging.flowsSeed.privateEvent", get label() { return i18nT("messaging.flowsSeed.privateEvent"); }, tone: "warn", bg: "#FAF1DE", fg: "#9A6A12" },
  queue: { labelKey: "messaging.flowsSeed.queue", get label() { return i18nT("messaging.flowsSeed.queue", "Queue"); }, tone: "success", bg: "#F7EFD6", fg: "#8A6A03" },
  appointment: { labelKey: "messaging.flowsSeed.appointment", get label() { return i18nT("messaging.flowsSeed.appointment", "Appointment"); }, tone: "primary", bg: "#DFF2F0", fg: "#0A7D74" },
};

export function flowStats(f: { steps?: any[] }): { steps: number; messages: number; decisions: number } {
  let steps = 0, messages = 0, decisions = 0;
  const walk = (arr?: any[]) => (arr || []).forEach((s) => {
    steps++;
    if (s.kind === "comms") messages++;
    else if (s.kind === "decision") { decisions++; (s.paths ?? []).forEach((p: { steps?: any[] }) => walk(p.steps)); }
  });
  walk(f.steps);
  return { steps, messages, decisions };
}
